<template>
  <span class="inline-flex">
    <!-- tao moi -->
    <i
      v-if="status == 0"
      class="font-size__medium fas fa-file-plus color__green icon-status icon-TAOMOI"
    ></i>
    <!-- dang trinh ky -->
    <i
      v-if="status == 1"
      class="font-size__medium fas fa-play-circle color__cyan icon-status icon-DANGTRIENKHAI"
    ></i>
    <!-- Cho ban hanh -->
    <i
      v-if="status == 4"
      class="font-size__medium fas fa-user-edit color__yellow icon-status icon-CHOPHEDUYET"
    ></i>
    <!-- Tu choi -->
    <i
      v-if="status == 6 || status == 7"
      class="font-size__medium fas fa-times-circle color__red icon-status icon-KETTHUC"
    ></i>
  </span>
</template>


<script>
export default {
  name: 'filterIconByStatus',
  props: ['status']
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/common/filterIconStatusVban.vue